import React, { useRef } from 'react';
import Container  from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Card  from 'react-bootstrap/Card';
import styles from '../../styles/ScholarshipsCountry.module.scss';
import CustomImage from '../CustomImage';
import { sliderSpeed } from '../../utils/constants';
import { isFrappeOrJotFormClass } from '../../utils/helpers';

const CountryPopularSholarshipProgramsComponent : React.FC =(props:any)=> {
  const scholarshipCountryData = props.pageData[0]
  const renderPaginationItem = (index: number, active: boolean) => {
    return <div className={`${active ? "active" : ""}`}>{index + 1}</div>;
  };
  const sliderRef = useRef<Slider>(null);
  const slidersettings = {
    dots: true,
    dotsClass: styles.sliderDots,
    infinite: true,
    speed: sliderSpeed.desktopSpeed,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 6,
    customPaging: (index: number) => renderPaginationItem(index, true),
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          rows: 2,
        }
      },
    ]
  };

  const mobileSliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: styles.mobileSliderDots,
    arrows: false,
  };

     
    return(
      <>
      <div className={styles.scholarshipPrograms}>
        <Container>
            <Row>
                <div><h2>{scholarshipCountryData?.scholarshipsPrograms?.title}</h2></div>
            </Row>
            <Row className='d-none d-sm-block'>
              {/* desktop view */}
               <div className={styles.sliderPosition}>
                <Slider {...slidersettings} ref={sliderRef}>
                  {scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms?.length > 0 &&
                  scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms.map((programsData:any,index:number)=>{
                       return(
                         <div className={styles.programSlider} key={index}>
                              <Card className={styles.card}>
                                <Card.Body className={styles.cardBody}>
                                  <Row>
                                    <Col xl={4} lg={4} md={12}>
                                      <div className={styles.program}>
                                        <div className={styles.cardImg}>
                                          <CustomImage src={programsData?.image?.url} width={100} height={100} alt={programsData?.image?.alternativeText} className={styles.borderRadiusImg}/>
                                        </div>
                                        <div className={styles.content}>
                                            <p>{programsData.subTitle}</p>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xl={6} lg={6} md={12}>
                                      <div className={styles.detail}>
                                        {programsData?.programs?.length > 0 &&
                                         programsData?.programs.map((data:any, index:number)=>{
                                              let programList = data.split(':');
                                              return(
                                                <p key={index}>
                                                  <span>{programList[0]} :</span>
                                                  {programList[1]}
                                                </p>
                                             )
                                         })
                                        }
                                      </div>
                                    </Col>
                                    <Col xl={2} lg={2} md={12}>
                                      <div className={styles.applyNow}>
                                        <a className={`btn ${isFrappeOrJotFormClass(scholarshipCountryData?.meta?.jotforms[0]?.jotformid)}  ${styles.viewMore}`}>Enquire Now</a>
                                      </div>
                                    </Col>
                                  </Row>
                                </Card.Body>
                              </Card>
                          </div>
                       )
                  })
                  }
                  
                </Slider>
                {scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms?.length > 6 &&
                <div className={styles.arrowsClass} style={{width: `${Math.ceil(scholarshipCountryData.scholarshipsPrograms.popularCountryPrograms.length / 6) * 100}px`, maxWidth: '100%'}}>
                  <div className={`${styles.btcircle} ${styles.floatLeft}`} onClick={() => sliderRef?.current?.slickPrev()}>
                    <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                  </div>
                  <div className={`${styles.btcircle} ${styles.floatRight}`} onClick={() => sliderRef?.current?.slickNext()}>
                    <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                  </div>
                </div>}
              </div>
            </Row>

            <Row className='d-block d-sm-none'>
              {/* mobile view */}
               <div className={styles.sliderPosition}>
                <Slider {...mobileSliderSettings}>
                  {scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms?.length > 0 &&
                  scholarshipCountryData?.scholarshipsPrograms?.popularCountryPrograms.map((programsData:any,index:number)=>{
                       return(
                         <div className={styles.programSlider} key={index}>
                              <Card className={styles.mobileCard}>
                                <Card.Body className={styles.mobileCardBody}>
                                      <div className={styles.mobileCardHeader}>
                                        <div className={styles.cardImg}>
                                          <CustomImage src={programsData?.image?.url} width={100} height={100} alt={programsData?.image?.alternativeText} className={styles.borderRadiusImg}/>
                                        </div>
                                        <div className={styles.content}>
                                            <p>{programsData.subTitle}</p>
                                        </div>
                                      </div>
                                      <div className={styles.mobileProgramDetails}>
                                        {programsData?.programs?.length > 0 &&
                                         programsData?.programs.map((data:any, index:number)=>{
                                              let programList = data.split(':');
                                              return(
                                                <p key={index}>
                                                  <span>{programList[0]} :</span>
                                                  {programList[1]}
                                                </p>
                                             )
                                         })
                                        }
                                      </div>
                                    
                                      <div className={styles.applyNow}>
                                        <a className={`btn ${isFrappeOrJotFormClass(scholarshipCountryData?.meta?.jotforms[0]?.jotformid)}  ${styles.viewMore}`}>Enquire Now</a>
                                      </div>
                                    
                                </Card.Body>
                              </Card>
                          </div>
                       )
                  })
                  }
                  
                </Slider>
              </div>
            </Row>
        </Container>
      </div>
      </>
    )

}
export default CountryPopularSholarshipProgramsComponent;